<template lang="pug">
  .post-heading(v-if="heading || subHeading")
    h4(v-if="subHeading") {{ subHeading }}
    h3(v-if="heading") {{ heading }}
</template>

<script>
export default {
  name: 'Heading',
  props: {
    heading: {
      type: String
    },
    subHeading: {
      type: String
    }
  }
};
</script>

<style lang="sass" scoped>
.post-heading
  h3
    @apply text-xl font-bold mb-4
</style>
